import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Buscadores que sienten que la espiritualidad tradicional ya no es suficiente.', 'Personas en crisis de identidad que saben que tiene que haber "algo más".', 'Aquellos que están cansados de repetir los mismos patrones emocionales y financieros.', 'Mentes despiertas que resuenan con la física cuántica y la metafísica profunda.'];
  const isNotFor = ['Personas que prefieren el confort del victimismo a la responsabilidad radical.', 'Quienes buscan una "fórmula mágica" para obtener cosas materiales sin cambiar su vibración.', 'Mentes cerradas que no están dispuestas a cuestionar la naturaleza de la realidad y el tiempo.'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-182">
      <div className="max-w-6xl mx-auto" data-id="element-183">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8" data-id="element-184">
          {/* Who is for */}
          <FadeIn direction="right" data-id="element-185">
            <div className="p-8 sm:p-10 rounded-2xl bg-gradient-to-b from-cyan-500/5 to-transparent border border-cyan-500/10 h-full" data-id="element-186">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-187">
                <span className="text-cyan-400" data-id="element-188">ESTO ES PARA TI</span> SI:
              </h3>
              <ul className="space-y-6" data-id="element-189">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-190">
                    <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" data-id="element-191" />
                    <span className="text-gray-300 text-lg leading-relaxed" data-id="element-192">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who is not for */}
          <FadeIn direction="left" delay={0.2} data-id="element-193">
            <div className="p-8 sm:p-10 rounded-2xl bg-gradient-to-b from-red-500/5 to-transparent border border-red-500/10 h-full" data-id="element-194">
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-195">
                <span className="text-red-400" data-id="element-196">NO ES PARA TI</span> SI:
              </h3>
              <ul className="space-y-6" data-id="element-197">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-198">
                    <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-199" />
                    <span className="text-gray-300 text-lg leading-relaxed" data-id="element-200">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}